/*
 *  I17INFPARCONSEPI18n.js
 *
 *  Created by Sébastien Hecart on 2018-08-05 14:21:23 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I17INFPARCONSEP_SECTION_0_TITLE: '',
  I17INFPARCONSEP_in_rendElecModule: 'Rendement électrique du module',
  I17INFPARCONSEP_in_rendThermiqueModule: 'Rendement thermique du module',
  I17INFPARCONSEP_in_tarif: 'Tarif B1 niveau 3 (TTC)',
  I17INFPARCONSEP_conclusion: 'Selon document du 11/2016',
  I17INFPARCONSEP_graph1: "Influence de la part d'autoconsommation sur le tarif C16",
  I17INFPARCONSEP_graph2: "Influence de la part d'autoconsommation sur l'économie en énergie primaire Ep"
}
